import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { PriceSectionSchema } from '../types/PriceSectionSchema';

const initialState: PriceSectionSchema = {
    
};

export const PriceSectionSlice = createSlice({
    name: 'PriceSection',
    initialState,
    reducers: {
        template: (state, action: PayloadAction<string>) => {
           
        },
    },
    // extraReducers: (builder) => {
    //     builder
    //         .addCase(, (state) => {
    //             state.error = undefined;
    //             state.isLoading = true;
    //         })
    //         .addCase(, (state) => {
    //             state.isLoading = false;
    //         })
    //         .addCase(, (state, action) => {
    //             state.isLoading = false;
    //             state.error = action.payload;
    //         });
    // },
});

export const { actions: PriceSectionActions } = PriceSectionSlice;
export const { reducer: PriceSectionReducer } = PriceSectionSlice;